var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF2214"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 24C16.9823 24 17.7782 23.2041 17.7782 22.2222C17.7782 21.2404 16.9823 20.4444 16.0004 20.4444C15.0186 20.4444 14.2227 21.2404 14.2227 22.2222C14.2227 23.2041 15.0186 24 16.0004 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 8C15.0227 8 14.2227 8.8 14.2227 9.77778V16.8889C14.2227 17.8667 15.0227 18.6667 16.0004 18.6667C16.9782 18.6667 17.7782 17.8667 17.7782 16.8889V9.77778C17.7782 8.8 16.9782 8 16.0004 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a31aa7648f87b90af0dd5c69c5091ea8.svg";
export { ForwardRef as ReactComponent };